﻿/**
 * @ngDoc Component
 * @name ng.component:aba
 *
 * @description
 *
 * O componete nos permite o uso de abas
 * de forma simples e pratica.
 *
 * @example
 *
 * <abas>
 *      <aba titulo="A">
 *          // corpo A
 *      </aba>
 *      <aba titlulo="B">
 *          // corpo B
 *      </aba>
 * </abas>
 *
 * @element E
 * @require lodash
 *
 */
'use strict';

var centralApp = angular.module('app.components');

centralApp.component('abas', {
        transclude: true,
        bindings: {
            selecionada: '=?'
        },
        controllerAs: '$ctrl',
        controller: AbasController,
        template: [
            '<div class="" role="tabpanel" data-example-id="togglable-tabs">',
                '<ul id="myTab" class="nav nav-tabs " role="tablist">',
                    '<li ng-repeat="aba in $ctrl.abas" ng-click="$ctrl.selecionar(aba)" ng-class="{active:aba.selecionado}" ',
                        'role="presentation" calss="{{ ::aba.class || \'\' }}">',
                        '<a href="" id="home-tab" role="tab" data-toggle="tab" aria-expanded="true">',
                            '<i ng-if="aba.icone" class="{{ ::aba.icone || \'\'}} text-muted" aria-hidden="true"></i> ',
                            '{{ ::aba.titulo }}',
                        '</a>',
                    '</li>',
                '</ul>',
                '<div id="TapContent" ng-transclude class="tab-content" style="margin-top: 30px"></div>',
            '</div>'
        ].join('')
    })
    .component('aba', {
        transclude: true,
        require: {
            abas: '^abas'
        },
        bindings: {
            titulo: '@',
            icone: '@?',
            class: '@?'
        },
        controllerAs: '$ctrl',
        controller: function () {
            this.$onInit = function () {
                this.abas.adicionar(this);
            };
        },
        template: [
            '<div role="tabpanel" class="tab-pane" ng-show="$ctrl.selecionado" ng-transclude aria-labelledby="profile-tab">',
            '</div>'
        ].join('')
    });

AbasController.$inject = ['Event'];
function AbasController(Event) {

    var $ctrl = this;

    $ctrl.abas = [];

    // Adicionar aba
    $ctrl.adicionar = function (aba) {
        if ($ctrl.abas.length == 0) {
            aba.selecionado = true;
        }
        $ctrl.abas.push(aba);

        Event.on('aba:' + aba.titulo, function () {
            $ctrl.selecionar(aba)
        })
    };

    // Seleciona aba
    $ctrl.selecionar = function (aba) {
        _.map($ctrl.abas, function (aba) {
            aba.selecionado = false;
        });

        $ctrl.selecionada = aba.titulo

        aba.selecionado = true;
    };

}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/aba/index.js
// module id = 304
// module chunks = 1